module.exports = __webpack_public_path__ + "static/media/testimonial1.edc58dc9.jpg";